import { render, staticRenderFns } from "./TicketDetailsCustom.vue?vue&type=template&id=3af17321&"
import script from "./TicketDetailsCustom.vue?vue&type=script&lang=js&"
export * from "./TicketDetailsCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports